import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SetupDetail } from '../setup/detail/Detail';
import { getSupplier } from './service/suppliers.service';
import { SupplierForm } from './model/Supplier.type';
import Loader from '../../Components/GlobalLoader/Loader';


export default function SupplierDetails() {
  const pageName = "Supplier Detail";
  const addUrl="/account/client/supplier/add";
  const listUrl="/account/client/supplier/list-view";
  const gridUrl="/account/client/supplier/grid-view";
  const editUrl="/account/client/supplier/edit";
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [supplier, setSupplier] = useState<SupplierForm>();
  const navigate = useNavigate();

  useEffect(() => {
      setLoading(true);
        if (id) {
          fetchSupplierData(id).then(()=>{
              setLoading(false);
          }).catch((error) => {
            setLoading(true);
            navigate("/404")
          });
        }
  }, [id])
  const fetchSupplierData = async (id: string): Promise<void> => {
    try {
      const response = await getSupplier(id);
      if (response.data && response.status === 200) {
        setSupplier(response.data); 
      } else {
        throw new Error("Failed to fetch supplier data");
      }
    } catch (error) {
      console.error("Failed to fetch supplier data:", error);
      throw error; // Re-throw the error if you want the caller to handle it
    }
  };
  const columns = [
    { label: "Client", value: `${supplier?.client?.name}(${supplier?.client?.code})` },
    { label: "Supplier Code", value: supplier?.code },
    { label: "Supplier Name", value: supplier?.name },
    { label: "Contact Name", value: supplier?.contact_name },
    { label: "Contact Telephone", value: supplier?.contact_phone },
    { label: "Contact Email", value: supplier?.contact_email },
    { label: "Address 1", value: supplier?.address_line_1 },
    { label: "Address 2", value: supplier?.address_line_2 },
    { label: "Address 3", value: supplier?.address_line_3 },
    { label: "Country", value: supplier?.country?.name },
    { label: "State/Province", value: supplier?.state_province },
    { label: "City", value: supplier?.city },
    { label: "Zip / Postal Code", value: supplier?.postal_code },
    { label: "Status", value: supplier?.is_active ? 'Active' : "Inactive" },
  ];
    return !loading ?(
      <SetupDetail
       pageName={pageName} 
       id={id??""}
       columns={columns}
       addUrl={addUrl}
       listUrl={listUrl}
       gridUrl={gridUrl}
       editUrl={editUrl}
       setupHeader={`Supplier (${supplier?.code})`}
      />
    ):<Loader/>
}
